<template>
  <div>
    <div v-if="cargando">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">{{ $t("page.general.cargar") }}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12" id="div_tareas">
          <div id="todo-lists-basic-demo"></div>
        </div>
      </div>
      <div
        class="row"
        v-if="usuario.usuario_sistema == 'Rep. Empresa' && empleados.length > 0"
      >
        <div class="col-12">
          <button
            type="button"
            v-on:click="Abrir_Modal_Nueva_Tarea_Otro_Empleado"
            class="btn btn-sm btn_blue btn-block"
          >
            {{ $t("page.tareas.agregar_tarea") }}
          </button>
        </div>
      </div>
    </div>
    <button
      type="button"
      id="button_agregar_nueva_tarea"
      class="btn btn-primary d-none"
      data-toggle="modal"
      data-target="#exampleModal_nueva_tarea"
    >
      Launch demo modal
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal_nueva_tarea"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModal_nueva_tareaLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModal_nueva_tareaLabel">
              {{ $t("page.tareas.agregar_tarea1") }}
            </h5>
            <button
              type="button"
              id="cerrar_modal_agregar_tarea"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-bind:class="loading_modal">
              <div class="d-flex justify-content-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">{{ $t("page.general.cargar") }}</span>
                </div>
              </div>
            </div>
            <div v-bind:class="result_modal">
              <div class="row">
                <div class="form-group col-12">
                  <label for="titulo">{{ $t("page.tareas.titulo") }}</label>
                  <input
                    type="text"
                    v-model="tarea.title"
                    class="form-control"
                    id="titulo"
                  />
                </div>
                <div class="form-group col-12">
                  <label for="descripcion">{{ $t("page.tareas.descripcion") }}</label>
                  <input
                    type="text"
                    v-model="tarea.description"
                    class="form-control"
                    id="descripcion"
                  />
                </div>
                <div class="form-group col-12">
                  <label for="fecha_vencimiento">{{ $t("page.tareas.fecha_vencimiento") }}</label>
                  <input
                    type="date"
                    v-model="tarea.dueDate"
                    class="form-control"
                    id="fecha_vencimiento"
                  />
                </div>
                <div class="form-group col-12">
                  <label for="empleado">{{ $t("page.tareas.empleado") }}</label>
                  <select
                    class="form-control"
                    v-model="tarea.cve_empleado"
                    id="empleado"
                  >
                    <option
                      v-for="trabajador,index of empleados"
                      :value="trabajador.cve_empleado"
                      :key="index+'trabajador'"
                    >
                      {{ trabajador.nombre_empleado }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-danger">
              {{ $t("page.tareas.cerrar") }}
            </button>
            <button
              type="button"
              class="btn btn-success"
              v-on:click="Agregar_Tarea"
            >
              {{ $t("page.tareas.guardar") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      para_mi: true,
      empleados: [],
      otro_empleado: false,
      cargando: true,
      loading_modal: "",
      result_modal: "d-none",
      tareas: [],
      autocomplete: {
        empleado: "",
      },
      tarea: {
        title: "",
        description: "",
        dueDate: new Date().toDateInputValue_Mes_Siguiente(),
        cve_empleado: null,
        status: 1,
      },
      todolist: null,
    };
  },
  methods: {
    Abrir_Modal_Nueva_Tarea_Otro_Empleado() {
      this.Listo_Modal();
      console.log(this.tarea.cve_empleado);
      $("#button_agregar_nueva_tarea").click();
    },
    Cerrar_Modal_Agregar_Tarea() {
      $("#exampleModal_nueva_tarea").modal("hide");
    },
    Agregar_Tarea(tarea) {
      var desde_modal = false;
      if (tarea.title == undefined) {
        this.Cargando_Modal();
        var tarea = this.tarea;
        desde_modal = true;
      } else {
        this.Cargando();
      }
      this.$http
        .post("tareas", {
          tarea: tarea,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.resp == "Excelente") {
            if (desde_modal) {
              this.Listo_Modal();
              this.autocomplete.empleado = "";
              this.tarea = {
                title: "",
                description: "",
                dueDate: "",
                cve_empleado: null,
                status: 1,
              };
              this.Cerrar_Modal_Agregar_Tarea();
            } else {
              this.Consultar();
            }
            swal("Excelente", "Tarea Agregada", "success");
          } else {
            this.Listo();
            swal("¡Ups!", respuestaJson.resp, "error");
          }
        })
        .catch((error) => {
          this.Listo();
          swal("¡Ups!", "Problemas para guardar la tarea", "error");
        });
    },
    Editar_Tarea(tarea) {
      console.log(tarea);
      this.Cargando();
      this.$http
        .put("tareas/" + tarea.id, {
          tarea: tarea,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.Consultar();
          if (respuestaJson.resp == "Excelente") {
            swal("Excelente", "Tarea Actualizada", "success");
          } else {
            swal("¡Ups!", respuestaJson.resp, "error");
          }
        })
        .catch((error) => {
          this.Listo();
          swal("¡Ups!", "Problemas para actualizar la tarea", "error");
        });
    },
    Eliminar_Tarea(tarea) {
      console.log(tarea);
      this.Cargando();
      this.$http
        .delete("tareas/" + tarea.id, {
          tarea: tarea,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.Consultar();
          if (respuestaJson.resp == "Excelente") {
            swal("Excelente", "Tarea Eliminada", "success");
          } else {
            swal("¡Ups!", respuestaJson.resp, "error");
          }
        })
        .catch((error) => {
          this.Listo();
          swal("¡Ups!", "Problemas para eliminar la tarea", "error");
        });
    },
    Ejecutar_Vista_Tareas() {
      var that = this;
      $("#todo-lists-basic-demo").lobiList({
        lists: [
          {
            id: "tareas",
            controls: false,
            title: "Tareas",
            defaultStyle: "lobilistTernium",
            items: that.tareas,
          },
        ],
        afterItemUpdate: function (lobilist, list) {
          that.Editar_Tarea(list);
        },
        afterItemAdd: function (lobilist, list) {
          var tarea = {
            title: list.title,
            description: list.description,
            dueDate: list.dueDate,
            cve_empleado: that.menu.usuario.cve_empleado,
            status: 1,
          };
          that.Agregar_Tarea(tarea);
        },
        afterItemDelete: function (lobilist, list) {
          that.Eliminar_Tarea(list);
        },
        afterMarkAsDone: function (lobilist, list, otro) {
          console.log(idtarea);
          var idtarea = $(list).parent().parent().attr("data-id");
          console.log(idtarea);
          for (var i = 0; i < that.tareas.length; i++) {
            if (that.tareas[i].id == idtarea) {
              that.tareas[i].done = true;
              that.Editar_Tarea(that.tareas[i]);
            }
          }
        },
        afterMarkAsUndone: function (lobilist, list, otro) {
          console.log(idtarea);
          var idtarea = $(list).parent().parent().attr("data-id");
          console.log(idtarea);
          for (var i = 0; i < that.tareas.length; i++) {
            if (that.tareas[i].id == idtarea) {
              that.tareas[i].done = false;
              that.Editar_Tarea(that.tareas[i]);
            }
          }
        },
        beforeDestroy: function () {
          console.log("beforeDestroy");
        },
        afterDestroy: function () {
          console.log("afterDestroy");
        },
      });

      $("#div_tareas").find(".datepicker").datepicker({
        autoclose: true,
        todayHighlight: true,
      });
    },
    Cargando() {
      this.cargando = true;
    },
    Cargando_Modal() {
      this.loading_modal = "";
      this.result_modal = "d-none";
    },
    Listo() {
      var that = this;
      this.cargando = false;
      $(document).ready(function () {
        that.Ejecutar_Vista_Tareas();
      });
    },
    Listo_Modal() {
      var that = this;
      $(document).ready(function () {
        that.loading_modal = "d-none";
        that.result_modal = "";
      });
    },
    Consultar() {
      console.log("consultar");
      this.Cargando();
      this.$http
        .get("tareas")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.tareas = respuestaJson;
          console.log(this.tareas);
          this.Listo();
        })
        .catch((error) => {
          console.log(error);
          //toastr.error('Problemas para consultar las tareas');
          this.Listo();
        });
    },
    Consultar_Empleados_Supervisor() {
      this.$http
        .get("tareas/empleados/supervisor")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.empleados = respuestaJson;
          if (this.empleados.length > 0) {
            this.tarea.cve_empleado = this.empleados[0].cve_empleado;
            console.log(this.tarea.cve_empleado);
          }
        })
        .catch((error) => {
          //toastr.error('Problemas para consultar las tareas');
        });
    },
  },
  watch: {
    "usuario.usuario_sistema": function () {
      this.Consultar_Empleados_Supervisor();
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    usuario() {
      return this.$store.getters.getUsuario;
    },
  },
  created() {},
  updated() {},
  mounted() {
    this.Consultar();
    this.Consultar_Empleados_Supervisor();
  },
};
</script>

<style>
.lobilist-wrapper {
  width: 90% !important;
}
.lobilist-wrapper {
  width: 100% !important;
  margin-right: 0px !important;
}
.lobilistTernium .lobilist-header {
  background-color: #ff9900 !important;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Tareas/Tareas.vue